import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { MySkeleton } from "./MySkeleton";

export const TableSkeleton = ({ rows = 5, columns = 3 }) => {
  return (
    <>
      {Array(rows)
        .fill()
        .map((_, rowIndex) => (
          <tr key={rowIndex} className="!bg-white">
            {Array(columns)
              .fill()
              .map((_, colIndex) => (
                <td key={colIndex} className="px-3 py-[10px]">
                  {/* <Skeleton
                    height={28}
                    width={`100%`}
                    baseColor="#eee"
                    highlightColor="#ccc"
                    duration={1.2}
                  /> */}
                  <MySkeleton width="70px" height="20px" />
                </td>
              ))}
          </tr>
        ))}
    </>
  );
};